import { Column } from 'react-table';

const ContactTypeTableColumnConfig: Column[] = [
    {
        Header: 'Id',
        accessor: 'id',
        disableSortBy: false,
    },
    {
        Header: 'Name',
        accessor: 'name',
        disableSortBy: false,
    },
];

export default ContactTypeTableColumnConfig;

export const DefaultVisibleContactTypeColumns = ['id', 'name'];

export const SearchableContactTypeTableColumnConfig = ['id', 'name'];
